module.exports = __webpack_public_path__ + "img/lateraltext.ef639172.png";